import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { App } from './App';
import { RequirementsPage } from './components/RequirementsPage';
export function AppRouter() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // Check authentication status on initial load and whenever it might change
  useEffect(() => {
    const checkAuthStatus = () => {
      const authStatus = localStorage.getItem('wingoAuthComplete');
      setIsAuthenticated(authStatus === 'true');
    };
    // Check on initial load
    checkAuthStatus();
    // Set up event listener for storage changes (in case of multiple tabs)
    window.addEventListener('storage', checkAuthStatus);
    return () => {
      window.removeEventListener('storage', checkAuthStatus);
    };
  }, []);
  return <BrowserRouter data-id="element-2">
      <Routes data-id="element-3">
        <Route path="/" element={isAuthenticated ? <Navigate to="/prediction" replace data-id="element-5" /> : <RequirementsPage setIsAuthenticated={setIsAuthenticated} data-id="element-6" />} data-id="element-4" />
        <Route path="/prediction" element={isAuthenticated ? <App data-id="element-8" /> : <Navigate to="/" replace data-id="element-9" />} data-id="element-7" />
        {/* Redirect any unknown routes based on authentication status */}
        <Route path="*" element={isAuthenticated ? <Navigate to="/prediction" replace data-id="element-11" /> : <Navigate to="/" replace data-id="element-12" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}